import { useState } from "react"
import { active_url, imvs_url } from "./host_data"
import { useQuery } from "react-query"
import axios from "axios"

export default async function GetImvs() {
    try {
        const response = await axios.get(active_url, {
            headers: {
                'api-key': 'xUp2jAz5hQZM#wCsKb',
                'Content-Type': 'application/json',
            },
        });
        return response.data; // Return the parsed JSON data
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error; // Rethrow the error to be handled by `useQuery`
    }
}